import { NewHolidayListForm } from "./_components/new-holiday-list-form";

const NewHolidayListPage = () => {
  return (
    <div className="p-3 max-h-[calc(100%-56px)] overflow-y-auto">
      <NewHolidayListForm />
    </div>
  );
};

export default NewHolidayListPage;
